import CookieStorage from "Core/commons/CookieStorage";
import Store from 'Services/Store';

window.ApiClient = (function() {
	const QUERY_TIMEOUT = 120000;
	const VERSION = 2;

	let axiosInstance = axios.create({
		baseURL: window.apiHost + '/v' + VERSION,
		timeout: QUERY_TIMEOUT,
		withCredentials: false,
		headers: {'X-Requested-With': "XMLHttpRequest"}
	});

	let webServiceParamsDefaultValues = {
		params: {},
		data: {},
		headers: {},
		method: 'GET'
	};

	function onAuthError(error)
	{
		window.Push.error(error);
		setTimeout(function () {
			Utils.reload();
		}, 3000); // @todo page de login + resent request
	}

	/**
	 * Get authorization token
	 * @returns {Promise<unknown>|Promise<string>}
	 */
	function getAuthorizationToken() {
		let currentStaffId = Store.get('user').id;
		let cookieStorage = new CookieStorage('api', 'access_token');
		//Get token in localStorage
		let cached = cookieStorage.get();
		if (cached) {
			let expire = (new Date(cached.expireAt)).getTime() - 60000; //-60s
			let now = (new Date()).getTime();
			if (cached.staffId == currentStaffId && expire > now) {
				return Promise.resolve( 'Bearer ' + cached.token);
			}
		}

		//Get token from saas
		let client = axios.create({
			timeout: QUERY_TIMEOUT,
			headers: {'X-Requested-With': "XMLHttpRequest"}
		});

		return new Promise(function (resolve, reject) {
			client.post('/web-token').then(function(response) {

				if (response.status !== 201 || !response.data.token) {
					return reject(new Error(window.i18n.gettext("Une erreur d'authentification s'est produite")));
				}

				let cachedData = response.data;
				cachedData.staffId = currentStaffId;
				cookieStorage.set(cachedData);

				return resolve( 'Bearer ' + response.data.token);
			}, onAuthError);
		});
	}

	function call(config) {
		if (config.signal?.aborted) {
			return Promise.reject(new DOMException('Aborted', 'AbortError'));
		}
		return new Promise(function (resolve, reject) {

			config.signal?.addEventListener('abort', function () {
				reject(new DOMException('Aborted', 'AbortError'));
			});

			getAuthorizationToken()
				.then(function (token) {
					let cancel;
					let CancelToken = axios.CancelToken;
					config = $.extend(true, {}, webServiceParamsDefaultValues, config);
					config.headers['Authorization'] = token;
					config.cancelToken = new CancelToken(function executor(c) {
						cancel = c;
					});
					let promise = axiosInstance.request(config);
					if (promise) {
						promise.abort = cancel;
					}
					return promise;
				}, onAuthError)
				.then(resolve, reject);
		});
	}


	function post(route, params, data, signal = undefined) {
		return call({url: route, params: params, data: data, method: 'POST', signal});
	}

	function patch(route, params, data, signal = undefined) {

		return call({url: route, params: params, data: data, method: 'PATCH', signal});
	}

	function put(route, params, data, signal = undefined) {

		return call({url: route, params: params, data: data, method: 'PUT', signal});
	}

	function get(route, params, signal = undefined) {

		return call({url: route, params: params, method: 'GET', signal});
	}

	function del(route, params, data = {}, signal = undefined) {
		return call({url: route, params: params, data, method: 'DELETE', signal});
	}

	return {
		call: call,
		post: post,
		get: get,
		patch : patch,
		put : put,
		del : del,
		isCancel: axios.isCancel,
	};
})();
